export enum FormDisplayMode {
  create = 1,
  edit = 2,
  read = 3
}

export type MessageType =  'info' | 'success' | 'warning' | 'error';
